export default {
  operatedBy: 'Gestita da',
  partlyOperatedBy: 'Gestita in parte da',
  operatedByGerman: '',
}
